import React from "react";
import {
  FaPhone,
  FaGithub,
  FaLinkedin,
  FaTwitter,
  FaEnvelope,
} from "react-icons/fa";
import styled from "styled-components";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";

const FooterWrapper = styled.section`
  height: 160px;
  background: ${(props) =>
    props.theme === "dark"
      ? "rgb(35,35,35)"
      : "linear-gradient(134deg, rgb(106, 152, 240) 0%, rgb(73, 97, 220) 99%);color: rgb(248, 248, 248)"};
  text-align: center;
  position: relative;
  padding: 14px 0;
  z-index: 12;
  div {
    display: flex;
    width: 30%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    font-size: 1.4rem;
  }
  p {
    font-size: 1.4rem;
  }
  @media screen and (max-width: 650px) {
    div {
      width: 60%;
      font-size: 1.1rem;
    }
    p {
      font-size: 1.2rem;
    }
  }
`;
const NavLink = styled.a`
  text-decoration: none;
  color: #fff;
  transition: 0.3s all ease-in-out;
  &:hover {
    transform: scale(1.3);
  }
`;

const Footer = () => {
  const { mode } = React.useContext(ThemeContext);
  return (
    <FooterWrapper theme={mode}>
      <p style={{ color: "#fff" }}>Designed and Developed by Rohan &#169;</p>
      <div>
        <NavLink
          href="tel:8918674566"
          aria-label="Telephone"
          rel="noreferrer"
          target="_blank"
        >
          <FaPhone />
        </NavLink>
        <NavLink
          href="mailto: kumarrohan2804@gmail.com"
          aria-label="email"
          target="_blank"
          rel="noreferrer"
        >
          <FaEnvelope />
        </NavLink>
        <NavLink
          href="https://twitter.com/rohan_kumar28"
          aria-label="Twitter"
          target="_blank"
          rel="noreferrer"
        >
          <FaTwitter />
        </NavLink>
        <NavLink
          href="https://github.com/kumarrohan2804"
          aria-label="GitHub"
          rel="noreferrer"
          target="_blank"
        >
          <FaGithub />
        </NavLink>

        <NavLink
          href="https://www.linkedin.com/in/rohan-kumar-baranwal-a25313148/"
          aria-label="Linkedin"
          target="_blank"
          rel="noreferrer"
        >
          <FaLinkedin />
        </NavLink>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
